import { CodiceFiscaleUtils, DateDay, DateMonth } from "@marketto/codice-fiscale-utils";
import belfioreConnector from "@marketto/belfiore-connector-embedded";


type Gender = 'M' | 'F';

interface CodiceFiscaleInput {
    name: string;
    surname: string;
    birthDateDay: number;
    birthDateMonth: number;
    birthDateYear: number;
    gender: Gender;
    birthplaceCountry: string;
    birthplace: string;
}


export async function calculateCodiceFiscale(input: CodiceFiscaleInput): Promise<string | null> {
    const codiceFiscaleUtils = new CodiceFiscaleUtils(belfioreConnector);

    return await codiceFiscaleUtils.parser.encodeCf({
        firstName: input.name,
        lastName: input.surname,
        year: input.birthDateYear,
        month: (input.birthDateMonth - 1) as DateMonth,
        day: input.birthDateDay as DateDay,
        gender: input.gender,
        place: input.birthplace,
    }); //VRNGNY07D68C351V
}

export async function extractBirthDate(taxCode: string): Promise<Date | null> {
    const codiceFiscaleUtils = new CodiceFiscaleUtils(belfioreConnector);

    return codiceFiscaleUtils.parser.cfToBirthDate(taxCode);
}


function normalize(str: string): string {
    return str
        .toUpperCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^A-Z]/g, "");
}

function codeSurname(surname: string): string {
    const s = normalize(surname);
    const consonants = s.replace(/[AEIOU]/g, "");
    const vowels = s.replace(/[^AEIOU]/g, "");
    return (consonants + vowels + "XXX").slice(0, 3);
}

function codeName(name: string): string {
    const n = normalize(name);
    const consonants = n.replace(/[AEIOU]/g, "");
    const vowels = n.replace(/[^AEIOU]/g, "");

    if (consonants.length >= 4) {
        return consonants[0] + consonants[2] + consonants[3];
    }

    return (consonants + vowels + "XXX").slice(0, 3);
}

export function splitFullNameByCF(fullName: string, cf: string): { order: string; name: string; surname: string }[] {
    const words = fullName.trim().split(/\s+/);
    const cfSurname = cf.slice(0, 3).toUpperCase();
    const cfName = cf.slice(3, 6).toUpperCase();

    const matches = [];

    for (let i = 1; i < words.length; i++) {
        const left = words.slice(0, i).join(" ");
        const right = words.slice(i).join(" ");

        // Caso: Nome Cognome
        if (codeName(left) === cfName && codeSurname(right) === cfSurname) {
            matches.push({
                order: "name surname",
                name: left,
                surname: right
            });
        }

        // Caso: Cognome Nome
        if (codeSurname(left) === cfSurname && codeName(right) === cfName) {
            matches.push({
                order: "surname name",
                name: right,
                surname: left
            });
        }
    }

    return matches;
}